(function($, ns, _) {
    'use strict';

    var cfg = {
        cache: {
            productItemTemplate: 'template.product-filters-search-results-item',
            searchResults: '.product-filters-search-results',
            input: 'input',
            btn: '.btn',
            searchAll: '.btn-all-results'
        },
        data: {
            searchDelay: 'search-delay',
            apiUrl: 'api-url',
            searchResultsPage: 'search-results-page',
            siteGroup: 'sitegroup',
            language: 'language',
            pageSize: 'page-size'
        },
        templates: {},
        classes: {},
        events: {
            click: 'click',
            keypress: 'keypress',
            keyup: 'keyup',
            change: 'change',
            focusout: 'focusout'
        }
    };

    ns.ProductSearch = function(container) {
        this.settings = cfg;

        this.container = container;
        this.init();
    };

    ns.ProductSearch.prototype = {
        init: function() {
            this.cacheItems();
            this.bindEvents();
            this.activate();
        },
        cacheItems: function() {
            let settings = this.settings,
                cache = settings.cache,
                data = settings.data,
                templates = settings.templates;

            // Elements
            this.searchInput = this.container.find(cache.input);
            this.searchBtn = this.container.find(cache.btn);
            this.searchResults = this.container.find(cache.searchResults);
            this.searchAll = this.container.find(cache.searchAll);

            // Templates
            templates.productItemTemplate = this.searchResults
                .find(cache.productItemTemplate)
                .html();

            // Data
            this.siteGroup = this.container.data(data.siteGroup);
            this.language = this.container.data(data.language);
            this.pageSize = this.container.data(data.pageSize);

            this.searchDelay = this.container.data(data.searchDelay);
            this.apiUrl = this.container.data(data.apiUrl);
            this.searchResultsPage = this.container.data(data.searchResultsPage);
        },
        bindEvents: function() {
            let settings = this.settings,
                cache = settings.cache,
                data = settings.data,
                events = settings.events,
                classes = settings.classes;

            this.searchInput.on(
                events.keyup,
                _.debounce(e => {
                    if (e.keyCode === 13) {
                        this.goToSearchResults();
                    }
                    if (e.keyCode === 27) {
                        this.emptySearch();
                    }
                    this.doSearch();
                }, this.searchDelay)
            );

            this.searchInput.on(events.change, () => {
                this.doSearch();
            });

            this.searchInput.on(events.focusout, () => {
                this.doSearch();
            });

            this.searchBtn.on(events.click, () => {
                this.goToSearchResults();
                return false;
            });

            this.container.on(events.click, cache.searchAll, () => {
                this.goToSearchResults();
                return false;
            });
        },
        activate: function() {
            // Clear search results html but store searchAll text first
            let searchAllText = this.searchAll.text();
            this.searchResults.html('');
            this.searchAll.text(searchAllText);
            this.previousKeyword = '';
        },

        doSearch: function() {
            let q = this.searchInput.val();

            q = q.trim();

            if (!q || !q.length || q.length < 3) {
                this.searchResults.html('');
                this.previousKeyword = '';
                return;
            }

            if (q === this.previousKeyword) {
                return;
            }
            this.previousKeyword = q;

            $.ajax({
                url: this.apiUrl,
                method: 'POST',
                data: {
                    sitegroup: this.siteGroup,
                    language: this.language,
                    pageSize: this.pageSize,
                    keyword: this.sanitize(q)
                },
                dataType: 'json'
            })
                .done(data => {
                    this.updateResults(data);
                })
                .fail(data => {
                    this.searchResults.html('');
                    console.error(data);
                });
        },

        updateResults: function(data) {
            let settings = this.settings,
                templates = settings.templates;

            this.searchAll.detach();
            this.searchResults.html('');
            let products = data.Products.slice(0, this.pageSize);

            for (let i = 0; i < products.length; i++) {
                let product = products[i];
                this.searchResults.append(
                    ns.fn.renderTemplate(product, templates.productItemTemplate)
                );
            }

            this.searchResults.append(this.searchAll);
        },

        goToSearchResults: function() {
            let keyword = this.searchInput.val();
            keyword = this.sanitize(keyword);
            window.location.href = this.searchResultsPage + '?keyword=' + keyword;
        },

        sanitize: function(str) {
            str = str.replace(/[&<>"'/]/gim, '');
            return str.trim();
        },

        emptySearch: function() {
            this.searchAll.detach();
            this.searchInput.val('');
            this.searchResults.html('');
        }
    };

    return ns;
})(window.jQuery, window.Dom || {}, window._ || {});
